import React from 'react';

import { InactiveUser } from '@apigrowfinance/pbolt-icons';
import Tag from '@apigrowfinance/pbolt-tag';
import { FormattedMessage } from 'react-intl';

const InactiveChip = () => (
    <Tag
        data-testid="inactiveChip"
        label={
            <FormattedMessage
                id="InactiveChip.inactive"
                defaultMessage="inactive"
            />
        }
        icon={<InactiveUser fontSize="inherit" sx={{ mr: 1 }} />}
        color="error"
    />
);

export default InactiveChip;
